export default __webpack_public_path__ + "static/media/(7).c10910c7.jpg";